import React from 'react'
import styles from './tag.module.scss'

function Tag({
  icon = '',
  children,
  handleClick,
  type,
  name,
  questionId,
  value,
  checked,
  price,
  genderId
}) {
  return (
    <label className={styles.tag}>
      <input
        type={type === 'multiple' ? 'checkbox' : 'radio'}
        name={name}
        className={styles.tag__control}
        onChange={handleClick}
        value={value}
        data-icon={icon}
        checked={checked}
        data-price={price}
        data-question-id={questionId}
        data-question-gender-id={genderId}
      />

      <div className={checked ? styles.tag__tag_filter : styles.tag__tag}>
        {icon}
        {children}
      </div>
      {checked && <span className={styles.tag__close}></span>}
    </label>
  )
}

export { Tag }
